import {
  useQuery,
  keepPreviousData,
  useMutation,
  useQueryClient,
} from "@tanstack/react-query";
import {
  getBatchGroupList,
  updateBatchGroupColour,
} from "../api/BatchGroupApi";
import { errorMessage, successMessage } from "../../../utils";
import { listItemButtonClasses } from "@mui/material";

const batchgroupsKeys = {
  all: ["batchgroups"],
  lists: () => [...batchgroupsKeys.all, "batchgrouplist"],
  batchgrouplist: (filters) => [...batchgroupsKeys.lists(), filters],
};

export const useBatchGroupsQuery = ({ list }) => {
  const queryClient = useQueryClient();
  //list query
  const listQuery = useQuery({
    queryKey: batchgroupsKeys.batchgrouplist(),
    queryFn: () => getBatchGroupList(),
    placeholderData: keepPreviousData,
    enabled: list,
  });

  const updateBatchColour = useMutation({
    mutationFn: ({ id, payload }) => updateBatchGroupColour({ id, payload }),
    onError: (error, variables) => {
      errorMessage(error.response.data);
      return variables.handleClose();
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: batchgroupsKeys.lists(),
      });
      successMessage("Batch colour updated successfully!!");
      return variables.handleClose();
    },
  });

  return {
    listQuery,
    updateBatchColour,
  };
};
